<div *ngIf="bcForm" class="row" id="parent-brouillon">
    <form focusInvalidInput [formGroup]="bcForm" (ngSubmit)="validate()" [class]="(this.bc.cycleBcs ?  this.bc.cycleBcs.length > 1 : false ) ? 'col-sm-10' : 'col-sm-12'">
        <div class="row">
            <div class="col-sm-12" style="display: flex; justify-content: space-between;">
                <h3 class="col-sm-6"> {{bc.fValide === 2 ? bc.code : "Cxxxxxxxxxx"}} en cours de saisie {{this.bc.societe ? '(' + this.bc.societe.code + ')' : ''}}</h3>
                <div class="col-sm-6" style="justify-content: space-between;">
    
                    <button color="default" mat-raised-button type="button" (click)="close()">
                        <mat-icon>arrow_back</mat-icon>Retour à la liste
                    </button>
                    <button [color]="'primary'" mat-raised-button
                        type="button" (click)="openCycleValidation()">
                        <mat-icon>share</mat-icon>Cycle de validation
                    </button>
                    <app-pdf-bc [bc]="bc"></app-pdf-bc>
                    <button [color]="'INVALID' === this.bcForm.status ? 'warn':'success'" mat-raised-button type="button" (click)="memorize()"
                    [matTooltip]="'INVALID' === this.bcForm.status ? 'Veuillez remplir correctement tous les champs obligatoires' : 'Enregistrer les informations'">
                        <mat-icon>save</mat-icon>Mémoriser
                    </button>
                    <button [color]="'success'" mat-raised-button [disabled]="'INVALID' === this.bcForm.status"
                        type="submit" [matTooltip]="'INVALID' === this.bcForm.status ? 'Veuillez remplir correctement tous les champs obligatoires' : 'Envoyer pour validation'">
                        <mat-icon>check</mat-icon>Envoyer en validation
                    </button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12"> 
                <app-bc-form [form]="bcForm" [detailBcInfo]="detailBcInfo" [amountHT]="bcLineHTs" [amountTTC]="bcLineTTCs" (withoutDocs)="Change($event)"
                    [amountTVA]="bcLineTVAs" (changeEmit)="getSelectedCa1($event)" (uploadDocument)="getSelectedDocuments($event)">
                </app-bc-form>
                <br/>
                <app-bcligne-enveloppe-create-form
                            [bcForm]="bcForm" 
                            (amountHTsEmit)="calculateHorsTaxes($event)" >
                </app-bcligne-enveloppe-create-form>
            </div>
        </div>
    </form>
    <div *ngIf="this.bc.cycleBcs ? this.bc.cycleBcs.length > 1 : false" class="col-sm-2"> 
        <app-cycles-bc [cycles]="bc.cycleBcs" [title]="bc.fValide === 2 ? bc.code : 'Cxxxxxxxxxx'"></app-cycles-bc> 
    </div>
</div>
<div *ngIf="bcForm === null">
    <div class="row">
        <div class="col-sm-12" style="display: flex; justify-content: space-between;">
            <h2 class="col-sm-6"> Bon de commande en cours de saisi </h2>
            <div class="col-sm-6" style="display: flex; justify-content: space-between;">
                <button disabled >
                    <mat-icon>cancel</mat-icon>Fermer
                </button>
                <button disabled >
                    <mat-icon>print</mat-icon>Imprimer
                </button>
                <button disabled >
                    <mat-icon>save</mat-icon>Mémoriser
                </button>
                <button disabled mat-raised-button>
                    <mat-icon>check</mat-icon>Envoyer en validation
                </button>
            </div>
        </div>
    </div>
    <div>
        <mat-spinner class ="spinner" mode="indeterminate"></mat-spinner>
    </div>
</div>
